// @ts-strict-ignore
import keyBy from 'lodash/keyBy';

import {customEventsClient} from 'common/report/queries/app-api/custom-events-client';
import {CustomEventDefinition} from 'common/report/util/saved-entities/types';

import {Store} from './store';

export const customEventsStore = new Store<CustomEventDefinition, CustomEventDefinition[]>({
  apiClient: customEventsClient,
  defaultValue: {},
  name: `custom-event-definitions`,
  transform: {
    index: (response) => keyBy(response, `id`),
    update: (customEvent: CustomEventDefinition) => {
      return {k: customEvent.id, v: customEvent};
    },
  },
});

export type CustomEventsStore = typeof customEventsStore;
